import type { RadioGroupContextProps } from 'antd/lib/radio';
import React from 'react';

const RadioGroupContext = React.createContext<RadioGroupContextProps | null>(null);

export const RadioGroupContextProvider = RadioGroupContext.Provider;

export default RadioGroupContext;
